import Select from './select';

const mapToOptions = (list: string[]) => list.map((name) => ({ name, value: name }));

export default function OldItkLocationFilters({
    country,
    region,
    city,
    countries,
    regions,
    cities,
    setCountry,
    setRegion,
    setCity,
}: {
    country: string;
    region: string;
    city: string;
    countries: string[];
    regions: string[];
    cities: string[];
    setCountry: (v: string) => void;
    setRegion: (v: string) => void;
    setCity: (v: string) => void;
}) {
    return (
        <>
            <Select
                name="Все страны"
                value={country}
                options={mapToOptions(countries)}
                onChange={(v) => setCountry(v || '')}
            />
            <Select
                name="Все регионы"
                value={region}
                options={mapToOptions(regions)}
                onChange={(v) => setRegion(v || '')}
            />
            <Select
                name="Все насел. пункты"
                value={city}
                options={mapToOptions(cities)}
                onChange={(v) => setCity(v || '')}
            />
        </>
    );
}
